import { createSlice } from '@reduxjs/toolkit'
import name from './name'

// Store
export const content = createSlice({
  name,
  initialState: {
    fetchingTemplateList: false,
    list: [],
    listSelect: [],
    total: 0,
    parentTemplatesList: []
  },
  reducers: {
    setFetchingTemplateList: (state) => {
      state.fetchingTemplateList = true
    },
    getTemplateList: (state, { payload }) => {
      state.list = payload.templates
      state.listSelect = payload.templates
      state.total = payload.total
      state.fetchingTemplateList = false
    },
    addTemplateList: (state, { payload }) => {
      state.list = state.list.concat(payload.templates)
      state.total = payload.total
    },
    updateTemplateIsActiveInList: (state, { payload: { pk, isActive } }) => {
      state.list.find(t => t.pk === pk).isActive = isActive
    },
    getParentTemplatesList: (state, { payload: { templates } }) => {
      templates = templates.sort((a, b) => {
        if (a.sk.startsWith('master-template')) return -1
        if (b.sk.startsWith('master-template')) return 1
        return 0
      })
      state.parentTemplatesList = templates
    },
    resetTemplateList: (state) => {
      state.list = []
      state.total = 0
    },
    resetTemplateListSelect: (state) => {
      state.listSelect = []
    }
  }
})

export const { setFetchingTemplateList, getTemplateList, addTemplateList, updateTemplateIsActiveInList, resetTemplateList, resetTemplateListSelect, getParentTemplatesList } = content.actions

export default content.reducer
